module.exports = __webpack_public_path__ + "static/media/Lateral_ES_Z1.96a63b10.png";